import { useOutletContext } from 'react-router-dom';
import { Button,Paper } from '@mui/material';
import { useLocation, useNavigate} from 'react-router-dom';
import * as XLSX from 'xlsx';
import React, { useState, } from 'react';
import moment from "moment";
import ReAuthDeleteDialog from '../../components/ReAuthDeleteDialog';
import { DataGrid,GridToolbarContainer,GridToolbarFilterButton, GridToolbarQuickFilter} from '@mui/x-data-grid';
import Activity from "../../features/db/activity";


export default function FilePage() {
	const { reportsContainer, searchValue, isAdmin } = useOutletContext();
	const [reports, setReports] = reportsContainer;
	const navigate = useNavigate();
	let location = useLocation();
	const [selectionModel, setSelectionModel] = useState([]);

	let reportz;

	const projectName = location.state ? location.state.projectName : undefined;
	const zone = location.state ? location.state.zone : undefined;
	const limit = location.state ? location.state.limit : undefined;

	if (projectName !== undefined && zone !== undefined) {
		// projectName = location.state.projectName;
		// zone = location.state.zone;
		reportz = reports.filter(report => {return report.project === projectName && (report.zone === zone || zone === "All Zones")});
	} else if (limit) {
		reportz = reports.sort((first, second) => moment(second.date, "DD-MM-YYYY") - moment(first.date, "DD-MM-YYYY"))
	} else {
		reportz = reports.sort((first, second) => moment(second.date, "DD-MM-YYYY") - moment(first.date, "DD-MM-YYYY")).slice(0, 10);
	}

	reportz = reportz.filter(doc => {
		if (searchValue === "")
			return true;
		else if (doc.id.toString().toLowerCase().includes(searchValue.toLowerCase()))
			return true;
		return false;
	});

	const downloadExcel = (reportArr) => {
		const worksheet = XLSX.utils.json_to_sheet(reportArr, { header: ["id", "project", "zone", "type", "hour", "area", "action", "weed", "other", "comment", "chemical", "time", "notification", "volume", "rate", "wind"] });
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
		XLSX.writeFile(workbook, "report.xlsx");
	};

	const handleExport = ()=>
	{
		if(selectionModel.length>0)
		{
			let reportsToExport = reportz.filter((rep) => { return selectionModel.includes(rep.id); });
			downloadExcel(reportsToExport);
		}
	}

	const handleDelete = ()=>
	{
		if(selectionModel.length > 0)
		{
			Activity.deleteAndUpdate(selectionModel,reports,setReports);
		}
	}

	const columns = [
		{ field: 'project', headerName: 'Project', flex:1},
		{ field: 'zone', headerName: 'Zone', flex:0.9},
		{ field: 'action', headerName: 'Action', flex:0.8},
		{ field: 'date', headerName: 'Date', flex:0.6},
	];

	const CustomToolbar = ({ setFilterButtonEl }) => (
		<GridToolbarContainer sx = {{m:1}}>
			<GridToolbarQuickFilter />
			<GridToolbarFilterButton ref={setFilterButtonEl} />
			{isAdmin?
				<>
					<Button onClick={handleExport}>Export to Excel</Button>
					<ReAuthDeleteDialog handleDelete = {handleDelete} selectionSize = {selectionModel.length}/>
				</>
			:null}
		</GridToolbarContainer>
	);
	
	const thang = (e)=>{
		
		let report = e.row;
		navigate(`/activity/${encodeURIComponent(report.project)}/${encodeURIComponent(report.zone)}`, { state: { report, isAdmin } });
	};

	return (
		<Paper varient="outlined" elevation={0}>
			<DataGrid
				autoHeight
				rows={reportz}
				columns={columns}
				checkboxSelection
				components={{Toolbar: CustomToolbar }}
				disableColumnSelector
				disableDensitySelector
				onSelectionModelChange = {(newSelectionModel) => {
					setSelectionModel(newSelectionModel);
				}}
				selectionModel={selectionModel}
				disableSelectionOnClick
				onRowClick={thang}
				getRowHeight={() => 'auto'}
			/>
		</Paper>
	)
}
